import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Backdrop, Modal, useMediaQuery } from '@material-ui/core';
import { AssuranceIcon } from 'images';
import MyContractBackground from 'images/AMC-BG-divider.svg';
import { useIntl } from 'react-intl';

export default function TransitionsModal(props: any) {
  const intl = useIntl();
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      paper: {
        backgroundColor: '#FAFAFA',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        borderRadius: '4px',
        outline: 'none',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
      },
      paperMobile: {
        backgroundColor: '#FAFAFA',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        borderRadius: '4px',
        outline: 'none',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        height: '98%',
      },
      header: {
        backgroundColor: '#FAFAFA',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '12px 16px',
        borderBottom: '1px solid #E7E7E7',
        backgroundImage: `url(${MyContractBackground})`,
        backgroundSize: 'cover',
      },
      close: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
      },
      closeTitle: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: 16,
        color: '#FAFAFA',
      },
      footer: {
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        borderTop: '1px solid #E7E7E7',
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '4px',
      },
      footerMobile: {
        backgroundColor: '#ffffff',
        boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
        borderTop: '1px solid #E7E7E7',
        bottom: 0,
        width: '100%',
        position: 'absolute',
      },
      content: {
        backgroundColor: '#FAFAFA',
        padding: '3%',

        [theme.breakpoints.up('md')]: {
          minWidth: 800,
        },
      },
      iconImage: {
        cursor: 'pointer',
        padding: 10,
        '&:hover': {
          background: 'rgba(0,0,0,0.04)',
        },
      },
      Backdrop: {
        background: 'rgba(0,0,0,0.6)',
      },
    }),
  );

  const classes = useStyles();
  const isNotMobile = useMediaQuery('(min-width:960px)');
  const modalClass = isNotMobile ? classes.modal : '';
  const paperClass = isNotMobile ? classes.paper : classes.paperMobile;
  const footerClass = isNotMobile ? classes.footer : classes.footerMobile;

  return (
    <Modal
      disableBackdropClick
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={modalClass}
      open={props.open}
      onClose={props.handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        classes: { root: classes.Backdrop },
      }}
    >
      <div className={paperClass}>
        {props.header ? (
          <div className={classes.header}>
            {props.header}
            {isNotMobile ? (
              <div className={classes.close}>
                <h4 className={classes.closeTitle}>
                  {intl.formatMessage({ id: 'modal.close' })}
                </h4>
                <img
                  className={classes.iconImage}
                  alt=""
                  onClick={/* istanbul ignore next */ () => props.handleClose()}
                  src={AssuranceIcon['close']}
                />
              </div>
            ) : (
              <img
                className={classes.iconImage}
                alt=""
                onClick={/* istanbul ignore next */ () => props.handleClose()}
                src={AssuranceIcon['closeResponsive']}
              />
            )}
          </div>
        ) : (
          <></>
        )}
        <div className={classes.content}>{props.content}</div>
        {props.footer ? (
          <div className={footerClass}>{props.footer}</div>
        ) : (
          <></>
        )}
      </div>
    </Modal>
  );
}
